export enum LegalDocumentType {
  MAIN = "MAIN",
  ACTIVE = "ACTIVE",
  ARCHIVED = "ARCHIVED",
}
